import { Box, Button, CircularProgress } from '@mui/material';
import { ProfileActionsProps } from './ProfileActions.types';

/**
 * Profile actions component providing edit, save, cancel, and delete functionality
 * Renders different button sets based on edit mode and station type
 *
 * Features:
 * - Edit button in view mode
 * - Save, cancel, and delete buttons in edit mode
 * - Delete button hidden for OKKO stations
 * - Loading states with spinners during operations
 * - Save button disabled when no changes made
 *
 * @param props - Component props containing action state and callbacks
 * @returns JSX element containing the appropriate action buttons
 */
export function ProfileActions({
  isEditMode,
  isOkkoStation,
  changedFieldsCount,
  saving,
  deleting,
  validationErrors,
  onEnterEditMode,
  onExitEditMode,
  onSave,
  onDelete
}: ProfileActionsProps): JSX.Element {
  return (
    <Box className="station-profile-dialog-actions">
      {!isEditMode ? (
        <Button onClick={onEnterEditMode} className="station-profile-action-button station-profile-edit-button">
          Редагувати
        </Button>
      ) : (
        <>
          {!isOkkoStation && (
            <Button
              onClick={onDelete}
              disabled={deleting}
              className="station-profile-action-button station-profile-delete-button"
            >
              {deleting ? <CircularProgress size={16} sx={{ color: '#d32f2f' }} /> : 'Видалити'}
            </Button>
          )}
          <Box className="station-profile-spacer" />
          <Button onClick={onExitEditMode} className="station-profile-action-button station-profile-cancel-button">
            Скасувати
          </Button>
          <Button
            onClick={onSave}
            disabled={changedFieldsCount === 0 || saving || (validationErrors && validationErrors.size > 0)}
            className="station-profile-action-button station-profile-save-button"
          >
            {saving ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Зберегти'}
          </Button>
        </>
      )}
    </Box>
  );
}
